import useAPI from '@/hooks/useAPI';
import NoteRepository from '@/repositories/NoteRepository';

const useNoteTypes = (enabled = true, contentTypeName: string) => {
  const noteRepository = NoteRepository();

  return useAPI({
    queryKey: ['getNoteTypes'],
    queryFn: async () => {
      return await noteRepository.getNoteTypes({ content_type__model: contentTypeName });
    },
    enabled
  });
};

export default useNoteTypes;
